<template>
    <div class="wrapper-content">
        <header class="header">
            <div class="container">
                <div class="header__container">
                    <div class="header__logo">
                        <a href="/" class="img"><img src="@/assets/images/nikahi/svg/logo.svg" alt="logo" /></a>
                        <div class="halal-logo"><img src="@/assets/images/nikahi/halal.png" alt="halal" /></div>
                    </div>
                    <div class="header__menu">
                        <ul class="items">
                            <li class="item"><a href="#booking">Бронирование</a></li>
                            <li class="item"><a href="#menu">Меню</a></li>
                            <li class="item"><a href="#degustation">Дегустация</a></li>
                            <li class="item"><a href="#rest">Ресторан</a></li>
                            <li class="item"><a href="#works">Порядок работы</a></li>
                            <li class="item"><a href="#photo">Фото</a></li>
                            <li class="item"><a href="#contacts">Контакты</a></li>
                        </ul>
                    </div>
                    <div class="btn-mobile">
                        <a href="tel:+79273546263" class="phone mm"
                            ><img src="@/assets/images/nikahi/svg/phone.svg" alt="phone" /></a
                        ><button type="button" class="btn-mobile__burger"><span></span></button>
                    </div>
                </div>
            </div>
        </header>
    </div>
    <div class="mobile _mask">
        <div class="mobile__block">
            <div class="mobile__head">
                <a href="/" class="mobile__logo"><img src="@/assets/images/nikahi/svg/logo-mobile.svg" alt="logo" /></a>
                <div class="mobile__btn-close"><span></span> <span></span></div>
            </div>
            <div class="mobile__menu">
                <ul>
                    <li><a href="#booking" class="mobile__menu-item">Бронирование</a></li>
                    <li><a href="#menu" class="mobile__menu-item">Меню</a></li>
                    <li><a href="#degustation" class="mobile__menu-item">Дегустация</a></li>
                    <li><a href="#rest" class="mobile__menu-item">Ресторан</a></li>
                    <li><a href="#works" class="mobile__menu-item">Порядок работы</a></li>
                    <li><a href="#photo" class="mobile__menu-item">Фото</a></li>
                    <li><a href="#contacts" class="mobile__menu-item">Контакты</a></li>
                </ul>
                <div class="ornament">
                    <span><img src="@/assets/images/nikahi/mobile/ornament.webp" alt="ornament" /></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    min-height: 88px;
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    @media (max-width: 768px) {
        position: fixed;
    }
}
@media (max-width: 1200px) {
    .header {
        min-height: 150px;
    }
    .header__logo {
        padding: 10px;
    }
}
@media (max-width: 768px) {
    .header {
        min-height: 56.36px;
        padding: 0;
    }
    .header__logo .halal-logo {
        width: 28px !important;
        height: 28px !important;
        margin-left: 15px !important;
    }
}
.header__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media (max-width: 1200px) {
    .header__container {
        flex-direction: column;
        justify-content: center;
    }
}
@media (max-width: 768px) {
    .header__container {
        flex-direction: unset;
        justify-content: space-between;
    }
}
@media (max-width: 768px) {
    .header__logo {
        padding: 0;
    }
}
.header__logo {
    display: flex;
    align-items: center;
}
.header__logo .img {
    width: 133.02px;
    height: 40px;
    display: block;
}
.header__logo .halal-logo {
    width: 41px;
    height: 40px;
    margin-left: 20px;
}
.header__logo .halal-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
@media (max-width: 768px) {
    .header__logo .img {
        width: 81px;
        height: 24.36px;
    }
}
.header__logo .img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
@media (max-width: 1200px) {
    .header__menu {
        padding: 20px 0;
    }
}
@media (max-width: 768px) {
    .header__menu {
        display: none;
    }
}
.header__menu .items {
    display: flex;
    align-items: center;
    margin-bottom: 0;
}
.header__menu .items .item {
    font-weight: 400;
    font-size: 16px;
    line-height: 25.6px;
    color: var(--black);
    font-family: var(--font-main);
    position: relative;
    flex: 0 0 auto;
}
.header__menu .items .item a {
    color: inherit;
}
.header__menu .items .item:not(:first-child) {
    margin-left: 50px;
}
@media (max-width: 992px) {
    .header__menu .items .item:not(:first-child) {
        margin-left: 20px;
    }
}
.header__menu .items .item:hover,
.header__menu .items .item:focus {
    transition: 0.2s ease 0.2s;
}
.header__menu .items .item:hover::before,
.header__menu .items .item:focus::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 1px;
    background: #333;
    animation: line 0.2s forwards 0.2s;
}
@keyframes line {
    0% {
        width: 0;
    }
    100% {
        width: 100%;
    }
}
.header .phone {
    width: 20px;
    height: 20px;
    margin-right: 20px;
}
.header .phone img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.btn-mobile {
    display: none;
}
@media (max-width: 768px) {
    .btn-mobile {
        display: flex;
        align-items: center;
    }
}
.btn-mobile__burger {
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    justify-content: center;
    flex-flow: column;
    position: relative;
    width: 20px;
    margin: 0 auto;
}
.btn-mobile__burger span {
    background: var(--dark-gray);
    width: 100%;
    height: 2px;
    margin: 0 auto;
}
.btn-mobile__burger span::before,
.btn-mobile__burger span::after {
    background: inherit;
    box-shadow: inherit;
    content: "";
    width: inherit;
    height: inherit;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    border-radius: inherit;
}
.btn-mobile__burger span::before {
    top: 8px;
}
.btn-mobile__burger span::after {
    bottom: 8px;
}
.mobile__block {
    width: 100%;
    max-width: 500px;
    height: 100%;
    padding: 15px 15px 65px;
    background-color: var(--blue);
    position: absolute;
    z-index: 999;
    left: -100%;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    opacity: 0;
}
.mobile__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.mobile__logo {
    width: 81px;
    height: 24.36px;
}
.mobile__logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.mobile__btn-close {
    position: relative;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
}
.mobile__btn-close span {
    position: absolute;
    background: var(--white);
    width: 25px;
    height: 2px;
}
.mobile__btn-close span:first-child {
    transform: rotate(45deg);
}
.mobile__btn-close span:last-child {
    transform: rotate(-45deg);
}
.mobile__menu {
    padding: 0 15px;
}
.mobile__menu ul {
    flex: 1 1 auto;
    word-break: break-word;
}
.mobile__menu ul li {
    margin-top: 50px;
    text-align: right;
}
.mobile__menu .ornament {
    display: flex;
    justify-content: flex-end;
    margin-top: 35px;
    width: 100%;
}
.mobile__menu .ornament span {
    display: block;
    width: 61px;
    height: auto;
}
.mobile__menu .ornament span img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.mobile__menu-item {
    font-weight: 600;
    font-size: 16px;
    line-height: 25.6px;
    color: var(--white);
}
._active-burger span {
    width: 0 !important;
    transition: width ease-in 0.1s;
}
._active-burger span::before {
    top: 0 !important;
    transition: top 0.1s ease-in;
    animation: rotateRight 0.2s forwards 0.2s;
}
._active-burger span::after {
    bottom: 0 !important;
    transition: bottom 0.1s ease-in;
    animation: rotateLeft 0.2s forwards 0.2s;
}
@keyframes rotateRight {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(45deg);
    }
}
@keyframes rotateLeft {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(-45deg);
    }
}
._active-move {
    animation: moveLeft 0.2s forwards 0.2s;
}
@keyframes moveLeft {
    0% {
        left: -100%;
        opacity: 0;
    }
    100% {
        left: 0;
        opacity: 1;
    }
}
</style>
